import React from 'react';
import useAuth from '@/hooks/useAuth';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { BodyThree } from '@/styles/theme/default/typography';
import Icon from '@/common/Icon';
import getImageUrl, { IMGIX } from '@/utils/images';
import RebrandedCartButton from '@/common/navigation/common/RebrandedCartButton';

function MenuList({ className, setSelected, search }) {
  const history = useHistory();
  const [, logout, { isAuthenticated }] = useAuth();
  const user = useSelector(state => state.Auth.user);
  const theme = useTheme();

  const handleLogout = () => {
    logout();
    history.push(`/`);
  };

  return (
    <Wrapper className={className}>
      {/*<MenuItem color={ theme.colors.caramel } name="Holiday Shop" onClick={ () => history.push('/collections/holiday-shop') } />*/}
      <MenuItem name="New" onClick={() => setSelected('new')} />
      <MenuItem name="Furniture" onClick={() => setSelected('furniture')} />
      <MenuItem name="Decor" onClick={() => setSelected('decor')} />
      <MenuItem name="Window" onClick={() => setSelected('window')} />
      {/*<MenuItem name="Wallpaper" onClick={() => setSelected('wallpaper')} />*/}
      <MenuItem name="Bedding" onClick={() => setSelected('bedding')} />
      <MenuItem name="Outdoor" onClick={() => setSelected('outdoor')} />
      <MenuItem name="Fabric" onClick={() => setSelected('fabric')} />
      <MenuItem name="Inspiration" onClick={() => setSelected('inspiration')} />
      <MenuItem name="Collaborations" onClick={() => setSelected('collaborations')} />
      <MenuItem name="Free Swatches" onClick={() => setSelected('swatches')} />
      <MenuItem name="Trade Program" onClick={() => setSelected('trade')} />
      {/*<MenuItem*/}
      {/*  name="Collaborations"*/}
      {/*  onClick={() => setSelected('collaborations')}*/}
      {/*/>*/}

      {/*<MenuItem name="Free Swatches" onClick={ () => history.push('/fabric-swatches') } />*/}

      {/*<MenuItem color={ theme.colors.caramel } name="Inspiration" onClick={ () => history.push('/theinside-irl') } />*/}

      <div className="bottom-menu">
        <li>
          <Link to={ isAuthenticated ? '/account' : '/login' }>
            <img src={getImageUrl('nav/login_icon.svg', IMGIX)} />
            { isAuthenticated ? 'My Account' : 'Login'}
          </Link>
        </li>

        <li><RebrandedCartButton showLabel /></li>

        <li>
          <a onClick={search}>
            <img src={getImageUrl('nav/search_icon.svg', IMGIX)} />
            Search
          </a>
        </li>

        {isAuthenticated && (
          <li>
            <BodyThree as="a" href="#" onClick={handleLogout}>
              Logout
            </BodyThree>
          </li>
        )}

        {user?.isAdmin && (
          <li>
            <BodyThree as="a" href="/admin/orders" onClick={handleLogout}>
              Dashboard
            </BodyThree>
          </li>
        )}
      </div>
    </Wrapper>
  );
}

export default MenuList;

const WrapperMenuItemLink = styled.li`
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const MenuItemLink = ({ name, to, external, mailto }) => {
  if (external) {
    return (
      <WrapperMenuItemLink>
        <a href={to} rel="noopener" target="_blank" className="body-two">
          <BodyThree className="body-two">{name}</BodyThree>{' '}
          <Icon className="icon" icon="ti-new-tab" size="18" color="black" />
        </a>
      </WrapperMenuItemLink>
    );
  }

  if (mailto) {
    return (
      <WrapperMenuItemLink>
        <a href={to} rel="noopener" target="_blank" className="body-two">
          <BodyThree className="body-two">{name}</BodyThree>
        </a>
      </WrapperMenuItemLink>
    );
  }

  return (
    <WrapperMenuItemLink>
      <Link to={to}>
        <BodyThree className="body-two">{name}</BodyThree>
      </Link>
    </WrapperMenuItemLink>
  );
};

const Wrapper = styled.ul`
  padding: 15px;

  .bold {
    font-weight: 500;
  }

  list-style: none;
  &:focus {
    outline: none;
  }

  .bottom-menu {
    margin-top: 34.8px;

    img {
      margin-right: 12.5px;
    }

    li {
      height: 51px;
      a {
        font-weight: 400;
        font-size: 16px;
        color: ${({ theme }) => theme.colors.charcoal};
        display: flex;
        align-items: center;
      }
    }

  }

  .menu-list-item {
    align-items: center;
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.gray}`};
    color: ${({ theme }) => theme.colors.charcoal};
    display: flex;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    height: 48px;
    justify-content: flex-start;
    line-height: 20px;
    position: relative;
    cursor: pointer;

    .arrow {
      position: absolute;
      right: 10px;
      img {
        width: 8px;
        height: 10px;
      }
  }
}`;

function MenuItem({ name, onClick, color }) {

  return (
    <div onClick={onClick} className="menu-list-item">
      <BodyThree color={color} className="body-two">
        {name}
      </BodyThree>
      <div className="arrow">
        <img
          src={getImageUrl('icons/right-arrow.svg', IMGIX)}
          alt="arrow"
        />
      </div>
    </div>
  );
}
